import { render, staticRenderFns } from "./BlockedTab.vue?vue&type=template&id=3a91b47a&scoped=true&"
import script from "./BlockedTab.vue?vue&type=script&lang=js&"
export * from "./BlockedTab.vue?vue&type=script&lang=js&"
import style0 from "./BlockedTab.vue?vue&type=style&index=0&id=3a91b47a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a91b47a",
  null
  
)

export default component.exports